import React, { useEffect, useState } from "react";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import useInvoiceApi from "../../../hooks/useInvoiceApi";

function CreateInvoiceNumberSection({ data, setData }) {
  const { generateInvoiceNo, validateInvoiceNo } = useInvoiceApi();
  const [loading, setLoading] = useState(false);
  const [validationLoading, setValidationLoading] = useState(false);
  const [touched, setTouched] = useState(false);

  const validation = async () => {
    if (!data?.invoiceNo) return;
    await validateInvoiceNo({
      setLoading: setValidationLoading,
      invoiceNo: data?.invoiceNo,
      callback: (val) => {
        setData({ ...data, invalidInvoice: !val });
      },
    });
  };

  const handleGenerate = async () => {
    await generateInvoiceNo({
      setLoading,
      callback: (invoice) => {
        setData({ ...data, invoiceNo: invoice });
      },
    });
  };

  useEffect(() => {
    validation();
  }, [data?.invoiceNo]);

  return (
    <div className="w-full flex mb-2 gap-4 items-center">
      <div className="flex flex-1">
        <CommonFreeTextInput
          label="Invoice NO"
          error={data?.invalidInvoice}
          value={data?.invoiceNo}
          onFocus={() => setTouched(true)}
          onBlur={() => {
            if (!data?.invoiceNo) {
              setData({ ...data, invalidInvoice: true });
            }
          }}
          onChange={(val) =>
            setData({
              ...data,
              invoiceNo: val,
            })
          }
        />
      </div>
      <div className="flex flex-1 items-center mt-4 gap-2">
        {validationLoading ? <div className="primaryLoader"></div> : <></>}
        <button className="" onClick={handleGenerate}>
          {loading ? (
            <div className="primaryLoader"></div>
          ) : (
            <span className="text-sm font-semibold text-primary1">
              Generate
            </span>
          )}
        </button>
      </div>
    </div>
  );
}

export default CreateInvoiceNumberSection;
